import { render } from "./Owner.vue?vue&type=template&id=57a3c35b&scoped=true"
import script from "./Owner.vue?vue&type=script&lang=js"
export * from "./Owner.vue?vue&type=script&lang=js"

import "./Owner.vue?vue&type=style&index=0&id=57a3c35b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57a3c35b"]])

export default __exports__